<template>
    <div class="channelItem marginItem" :class="{'marginItemDark':isDark}">
        <div class="title">
            <div class="left">
                <p>
                    <img src="@/assets/img/datamodel/match/iconSmallMargin.png" alt="图表">
                    {{data.info.name}}
                </p>
                <em v-if="data.is_buy == 1 && data.has_data == 1" @click="goto(data.analy.url)">查看详情分析 ></em>
                <span v-else>{{  data.info.tag }}</span>
            </div>
            <div class="right">{{data.info.buy_count}}人解锁</div>
        </div>
        <div class="con">
            <div v-if="data.is_buy == 0 && data.has_data == 1" class="noVipHaveData" @click="goto(data.info.url)">
                <img v-if="isDark" src="@/assets/img/datamodel/match/noDataMarginDark.png" alt=""/>
                <img v-else src="@/assets/img/datamodel/match/noDataMargin.png" alt=""/>
            </div>
            <div v-if="data.has_data == 0" class="noData">
                <div class="txt">
                    {{ data.info.desc }}
                </div>
                <div class="btm">
                    <div class="top">
                       <p class="res"> <span>历史命中</span> {{ dealDate(data.schedule.match_time) }} {{ data.schedule.sclass_name }}</p>
                       <p class="btn" @click="goto(data.info.url)">查看更多比赛预测</p>
                    </div>
                    <div class="info">
                        <div class="bettel">
                            <div class="team">
                                <p>{{ data.schedule.home_team }}</p>
                                <span>{{ data.schedule.home_score }}</span>
                            </div>
                            <div class="team">
                                <p>{{ data.schedule.guest_team }}</p>
                                <span>{{ data.schedule.guest_score }}</span>
                            </div>
                        </div>
                        <div class="predict">
                            <img src="../../../assets/img/datamodel/match/hit.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data.is_buy == 1 && data.has_data == 1" class="haveData">
                <div class="predictInfo">
                    <div class="pitem" :class="{'active1':data.analy.predict_first == 1,'active2':data.analy.predict_second == 1}">
                        <p>主胜</p>
                        <span>{{ data.analy.match_odds.current_left }}</span>
                        <i v-if="data.analy.predict_first == 1">主</i>
                        <i v-if="data.analy.predict_second == 1">次</i>
                    </div>
                    <div class="pitem" :class="{'active1':data.analy.predict_first == 3,'active2':data.analy.predict_second == 3}">
                        <p>平局</p>
                        <span>{{ data.analy.match_odds.current_middle }}</span>
                        <i v-if="data.analy.predict_first == 3">主</i>
                        <i v-if="data.analy.predict_second == 3">次</i>
                    </div>
                    <div class="pitem" :class="{'active1':data.analy.predict_first == 2,'active2':data.analy.predict_second == 2}">
                        <p>客胜</p>
                        <span>{{ data.analy.match_odds.current_right }}</span>
                        <i v-if="data.analy.predict_first == 2">主</i>
                        <i v-if="data.analy.predict_second == 2">次</i>
                    </div>
                </div>
                <div class="marginInfo">
                    <div class="name">Margin值</div>
                    <div class="marginOdds">
                        <div class="oddsItem">
                            <p class="tips">初</p>
                            <p class="odds">
                                <span>{{ data.analy.profit_loss_index.initial_left }}</span>
                                <span>{{ data.analy.profit_loss_index.initial_middle }}</span>
                                <span>{{ data.analy.profit_loss_index.initial_right }}</span>
                            </p>
                        </div>
                        <div class="oddsItem">
                            <p class="tips">即</p>
                            <p class="odds">
                                <span :class="{'red':parseFloat(data.analy.profit_loss_index.current_left) > parseFloat(data.analy.profit_loss_index.initial_left),'green':parseFloat(data.analy.profit_loss_index.current_left) < parseFloat(data.analy.profit_loss_index.initial_left)}">
                                    <em>{{ data.analy.profit_loss_index.current_left }}</em>
                                    <img v-if="parseFloat(data.analy.profit_loss_index.current_left) > parseFloat(data.analy.profit_loss_index.initial_left)" src="../../../assets/img/datamodel/match/iconOddsUp.png" alt="">
                                    <img v-if="parseFloat(data.analy.profit_loss_index.current_left) < parseFloat(data.analy.profit_loss_index.initial_left)" src="../../../assets/img/datamodel/match/iconOddsDown.png" alt="">
                                </span>
                                <span :class="{'red':parseFloat(data.analy.profit_loss_index.current_middle) > parseFloat(data.analy.profit_loss_index.initial_middle),'green':parseFloat(data.analy.profit_loss_index.current_middle) < parseFloat(data.analy.profit_loss_index.initial_middle)}">
                                    <em>{{ data.analy.profit_loss_index.current_middle }}</em>
                                    <img v-if="parseFloat(data.analy.profit_loss_index.current_middle) > parseFloat(data.analy.profit_loss_index.initial_middle)" src="../../../assets/img/datamodel/match/iconOddsUp.png" alt="">
                                    <img v-if="parseFloat(data.analy.profit_loss_index.current_middle) < parseFloat(data.analy.profit_loss_index.initial_middle)" src="../../../assets/img/datamodel/match/iconOddsDown.png" alt="">
                                </span>
                                <span :class="{'red':parseFloat(data.analy.profit_loss_index.current_right) > parseFloat(data.analy.profit_loss_index.initial_right),'green':parseFloat(data.analy.profit_loss_index.current_right) < parseFloat(data.analy.profit_loss_index.initial_right)}">
                                    <em>{{ data.analy.profit_loss_index.current_right }}</em>
                                    <img v-if="parseFloat(data.analy.profit_loss_index.current_right) > parseFloat(data.analy.profit_loss_index.initial_right)" src="../../../assets/img/datamodel/match/iconOddsUp.png" alt="">
                                    <img v-if="parseFloat(data.analy.profit_loss_index.current_right) < parseFloat(data.analy.profit_loss_index.initial_right)" src="../../../assets/img/datamodel/match/iconOddsDown.png" alt="">
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isLogin, doLogin, isJHAppios, isJHApp } from "../../../utils/base"
export default {
    name: 'marginItem',
    props: ['data', 'isDark'],
    methods: {
        gobuy () {
            if (!isLogin) {
                doLogin();
                return
            }
            let url = ""
            if (isJHAppios() || !isJHApp()) {
                url = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.data.info.data_type;
            } else {
                url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.data.info.data_type;
            }
            this.$emit('gobuy', url)
        },
        goto (url) {
            this.$emit('goModel', url)
        },
        dealDate (str) {
            return str.substring(5, 10).replace('-', '/')
        }
    }
}
</script>

<style lang="less" scoped>
.marginItem{
    .noData{
        .predict{
            width: 50px;
            height: 50px;
            img{
                width: 100%;
            }
        }
    }
    .haveData{
        text-align: center;
        .predictInfo{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 40px;
            background-color: #F5F5F5;
            border-radius: 5px;
            overflow: hidden;
            .pitem{
                width: 33.33%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: relative;
                p{
                    font-size: 15px;
                    color: #333;
                    line-height: 20px;
                    font-weight: bold;
                }
                span{
                    font-size: 12px;
                    color: #666666;
                    line-height: 15px;
                }
                i{
                    display: block;
                    width: 15px;
                    height: 15px;
                    background-color: #ffffff;
                    border-bottom-right-radius: 5px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    font-size: 10px;
                    color: #FF5048;
                    line-height: 15px;
                }
            }
            .active1{
                background-color: #FF5048;
                p{
                    color: #ffffff;
                }
                span{
                    color: #ffffff;
                }
            }
            .active2{
                background-color: #FF7436;
                p{
                    color: #ffffff;
                }
                span{
                    color: #ffffff;
                }
            }

        }
        .marginInfo{
            width: 100%;
            height: 48px;
            border-radius: 5px;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
            border: 1px solid #f5f5f5;
            .name{
                width: 72px;
                line-height: 48px;
                color: #333333;
                font-size: 12px;
                border-right: 1px solid #f5f5f5;
            }
            .marginOdds{
                width: calc(100% - 72px);
                .oddsItem{
                    width: 100%;
                    height: 24px;
                    border-bottom: 1px solid #f5f5f5;
                    display: flex;
                    justify-content: space-between;
                    .tips{
                        width: 30px;
                        font-size: 12px;
                        color: #333333;
                    }
                    .odds{
                        width: calc(100% - 30px);
                        display: flex;
                        justify-content: space-between;
                        span{
                            width: 33.33%;
                            border-left: 1px solid #f5f5f5;
                            font-size: 12px;
                            color: #333333;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            img{
                                width: 6px;
                                margin-left: 2px;
                            }
                        }
                        .red{
                            color: #FF5048;
                        }
                        .green{
                            color: #43A000;
                        }
                    }
                }
            }
        }
    }
}
.marginItemDark{
    .haveData{
        background-color: #232323 !important;
        .predictInfo{
            background-color: #232323;
            .pitem{
                p{
                    color: #d3d3d3;
                }
                span{
                    color: #a6a6a6;
                }
                i{
                    // background-color: #191919;
                }
            }
        }
        .marginInfo{
            border-color: #232323;
            .name{
                color: #d3d3d3;
                border-color: #191919;
            }
            .marginOdds{
                .oddsItem{
                    border-color: #191919;
                    .tips{
                        color: #d3d3d3;
                    }
                    .odds{
                        span{
                            color: #d3d3d3;
                            border-color: #191919;
                        }
                    }
                }
            }
        }
    }
}
</style>
